import { ExtendedFontFamily } from './extendedFonFamily';

export * from './extendedFonFamily';

export default ExtendedFontFamily;
